// extracted by mini-css-extract-plugin
module.exports = {"add-coupon":"_2dJDmIdhx1","tip-style":"_1LAPNZTX5x","radio-group":"F2DMSulReP"};